import uiConfig from './uiConfig';

export const uiConfigTable = uiConfig.uiConfigTable;
export const uiConfigReadOnly = uiConfig.uiConfigReadOnly;
